/*
 * Module for the Contribution Rate Detail page
*/
rs.module("content/system/configuration/contributionrates/detail",

    [
        "controls/components/event-banner",
        "common/select-helper",
        "common/visibility"
    ],

    function (eventBanner, selectHelper, visibility) {

        var _executeSelectionChanged;
        var _criteria;

        //
        // Initialize
        //
        function initialize(jsSelectors, contributionMasterKey, backendUrls, codeValues, grid) {

            // Unpack js selectors
            _criteria = $.js(jsSelectors.criteria);

            var detailHistoryUpdateToken = _criteria.js(jsSelectors.detailHistoryUpdateToken);
            var detailHistoryContributionRuleKey = _criteria.js(jsSelectors.detailHistoryContributionRuleKey);
            var detailHistoryAddButton = _criteria.js(jsSelectors.detailHistoryAddButton);
            var contributionRateTypeSelect = _criteria.js(jsSelectors.contributionRateTypeSelect);
            var detailHistoryEffectiveDateInput = _criteria.js(jsSelectors.detailHistoryEffectiveDateInput);
            var detailHistoryTerminationDateInput = _criteria.js(jsSelectors.detailHistoryTerminationDateInput);
            var tableNameSelect = _criteria.js(jsSelectors.detailHistoryTableNameSelect);
            var rateHistoryCard = _criteria.js(jsSelectors.rateHistoryCard);
            var rateHistoryPartialView = _criteria.js(jsSelectors.rateHistoryPartialView);

            // Get Select Helpers
            var contributionRateTypeSelectHelper = selectHelper.getHelper(contributionRateTypeSelect);
            var tableNameSelectHelper = selectHelper.getHelper(tableNameSelect);

            // On grid selection change, we will update the detail history form data.
            grid.selectionChanged(function (values, rows) {
                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    // Retrieve new form data
                    $.get(
                        backendUrls.loadDetailHistoryForm,

                        { contributionRuleKey: values[0] })

                        .done(function (data) {
                            contributionRateTypeSelectHelper.setValue(data.rateType);
                            detailHistoryContributionRuleKey.val(data.contributionRuleKey);
                            detailHistoryEffectiveDateInput.val(data.effectiveDate);
                            detailHistoryTerminationDateInput.val(data.terminationDate);
                            detailHistoryUpdateToken.val(data.updateToken);

                            tableNameSelectHelper.loadOptionsFrom(backendUrls.loadTableNamesByRate, { rateType: data.rateType, selectedTable: data.tableName });
                            tableNameSelectHelper.setDisabled(data.rateType != codeValues.ageRate && data.rateType != codeValues.flat);

                            // Load Partial View
                            LoadRateHistoryPartialView(values[0]);
                        });

                    clearBanner();
                }

                _executeSelectionChanged = true;
            });

            // Load the correct partial view
            function LoadRateHistoryPartialView(ruleKey) {
                $.get(backendUrls.loadRateHistoryPartialView,
                    { contributionRuleKey: ruleKey, contributionRuleMasterKey: contributionMasterKey })
                    .done(function (result) {
                        rateHistoryPartialView.html(result);
                        _resetValidations();
                    });
                visibility.show(rateHistoryCard);
            }

            // When rate type changes, change table names drop down
            contributionRateTypeSelect.change(function () {

                var rateType = contributionRateTypeSelect.val();

                tableNameSelectHelper.setDisabled(rateType != codeValues.ageRate && rateType != codeValues.flat).selectIndex(0)
                    .loadOptionsFrom(backendUrls.loadTableNamesByRate, { rateType: contributionRateTypeSelect.val() });
            });

            // On the add button click, clear detail history form
            detailHistoryAddButton.click(function () {
                clearBanner();
                visibility.hide(rateHistoryCard);
                grid.selectedValues = null;
                detailHistoryContributionRuleKey.val(-1);
                [
                    detailHistoryUpdateToken,
                    detailHistoryEffectiveDateInput,
                    detailHistoryTerminationDateInput
                ].forEach((input) => input.clearErrors().val(''));

                contributionRateTypeSelectHelper.selectIndex(0);
                tableNameSelectHelper
                    .setDisabled(contributionRateTypeSelect.val() != codeValues.ageRate && contributionRateTypeSelect.val() != codeValues.flat)
                    .loadOptionsFrom(backendUrls.loadTableNamesByRate, { rateType: contributionRateTypeSelect.val() });

            });

            // Clear the event banner of all messages.
            function clearBanner() {
                eventBanner.removeErrorMessages();
                eventBanner.removeInformationalMessages();
            }
        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            var form = _criteria;
            $.validator.resetValidation(form);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);